import {get, post} from './http';

// Which tab of the design system's App Feedback dialog it came from; a bug goes to Jira as a Bug,
// feedback as a Story.
export type FeedbackKind = 'feedback' | 'bug';

export type CreateFeedbackRequest = {
  kind: FeedbackKind;
  page: string;
  message?: string | undefined;
  last_error?: string | undefined;
  rating?: number | undefined;
  title?: string | undefined;
  url?: string | undefined;
  impact?: string | undefined;
};

export type Feedback = {
  id: string;
  kind: FeedbackKind;
  page: string;
  submitted_by: string;
  message: string;
  created_at: string;
  hidden: boolean;
  last_error: string | null;
  rating: number | null;
  title: string | null;
  url: string | null;
  impact: string | null;
};

export type PendingFeedbackNotification = {
  id: string;
  page: string;
  message: string;
  jira_created_at: string;
};

export const feedbackApi = {
  create: async (body: CreateFeedbackRequest) =>
    post<CreateFeedbackRequest, Feedback>('/feedback', body),

  // Admin: listing of everything analysts have submitted; hidden items are excluded unless requested.
  list: async (showHidden = false) => get<Feedback[]>('/admin/feedback', {show_hidden: showHidden}),

  // Admin: non-destructive dismissal - never deletes the underlying row.
  hide: async (id: string) => post<undefined>(`/admin/feedback/${id}/hide`),
  unhide: async (id: string) => post<undefined>(`/admin/feedback/${id}/unhide`),

  // Admin: tells the API a Jira ticket was started so the submitter gets notified.
  markJiraCreated: async (id: string) => post<undefined>(`/admin/feedback/${id}/jira-created`),

  // Analyst: own feedback with a Jira ticket started, not yet dismissed.
  minePending: async () => get<PendingFeedbackNotification[]>('/feedback/mine/pending'),
  acknowledge: async (id: string) => post<undefined>(`/feedback/${id}/acknowledge`)
};
